export default "__VITE_PUBLIC_ASSET__9c8cd8c0__"